<template>
  <div class="digitalScreen-Monitoring">
    <template v-if="!isLoading && !loadingData">
        <div class="digitalScreen-monitoring__wrapper">
          <div class="title">
            <h1 class="xsmall-title">{{ campaign.title}}</h1>
          </div>
          <!-- <div class="content">
            <button class="btn-regular secondary" @click="goToContents">
              <i class="icon-download"></i>
              <span>Log Prof</span>
            </button>
          </div> -->
        </div>
        <div class="digitalScreen-monitoring__period">
          <label-status class="status" :progress="displayStatus(campaign.status)"/>
          <span class="subhead period-text"> Campaign period</span>
          <span class="subhead">{{ displayPeriod(campaign.start, campaign.end) }}</span>
        </div>
      <div class="digitalScreen-monitoring__status">
        <span class="subhead status-text">Report date</span>
        <span class="subhead">{{reportDate}}</span>
      </div>
      <div class="digitalScreen-monitoring__table">
         <adx-table text="Tooltip button" 
          :loading.sync="isLoading"
          :items.sync="data"  
          :isEmpty.sync="isEmpty">
        </adx-table>
      </div>
      <div class="digitalScreen-monitoring__footer">
        <div class="digitalScreen-monitoring__footer__range" v-if="!isLoading && !isEmpty">{{getDataRange}} of {{count}} Items</div>
        <!-- <adx-pagination 
          @change-page="selectPage" 
          :maxPage="maxPage" 
          :selectedPage="selectedPage" /> -->
      </div>
    </template>
    <div v-else >
      <adx-loading class="digitalScreen-monitoring__loading" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import Empty from '@/components/NotFound/Selection'
import Loading from '@/components/Loading/Primary'
import LabelStatus from '@/components/StatusLabel'
import table from '@/components/Table'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import { formatShortDateTime, formatShortDate} from '@/lib/util'
import { helpers } from '@/lib/validation/'
import moment from 'moment'

export default {
  name: 'adx-dashboard-campaign-monitoring',
  components: {
    'adx-pagination': Pagination,
    'adx-empty': Empty,
    'adx-loading': Loading,
    'label-status': LabelStatus,
    'adx-table': table,
  },
  props: {

  },
  data() {
    return {
      searchText: '',
      selectedPage: 1,
      maxPage: 1,
      campaignId: null,
      campaign: {
        title: '',
        start: '',
        end: '',
        report: '',
        status: '',
        devices: []
      },
      campaignStatus:{
        label: 'ACTIVE',
        value: 'active'
      },
      count: 0,
      isLoading: false,
      loadingData: false,
      data: {
        checkbox: false,
        head: [
          {
            title: "ID",
            type: "text",
            display: "display:none;"
          },
          {
            title: "LOCATION",
            type: "description"
          },
          {
            title: "PLACEMENT",
            type: "text"
          },
          {
            title: "ACTUAL PLAY / DAY",
            type: "number"
          },
          {
            title: "MIN PLAYED / DAY",
            type: "number"
          },
        ],
        body : []
      },
    }
  },
  computed: {
    isEmpty: function(){
      return this.data.body && this.data.body.length? false: true
    },
    getDataRange: function(){
      return (this.count%15===0 || this.selectedPage===1) && this.count>15?this.selectedPage*15:(this.selectedPage*15-15)+(this.count%15)
    },
    reportDate: function(){
      let yesterday = formatShortDate(new Date().setDate(new Date().getDate() - 1))
      if(this.campaign.end){
        if (yesterday < this.campaign.end){
          return yesterday
        } else {
          return formatShortDate(this.campaign.end)
        }
      }
    }
  },
  watch: {
    searchText: helpers.debounce(function () {
      this.$nextTick(function () {
        this.getCampaignDetail()
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {
    this.campaignId = this.$route.params.id
    this.isLoading = true
    this.getCampaignDetail()
    this.isLoading = false
  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    focusSearch() {
      this.$refs.inputSearch.focus()
    },
    selectPage(page) {
      this.selectedPage = page
      this.getCampaignDetail()
    },
    getCampaignDetail() {
      (async () => {
        this.loadingData = true

        let param = {}
        param.page = this.selectedPage
        if (this.searchText) {
          param.search = this.searchText
        }
        let response = await api.get(apiV2.dashboardMonitoringDS(this.campaignId), {needToken: true})
        if (response.status == 200) {
          let data = response.data
          let devices = data.devices
          this.campaign = data
          this.maxPage = devices.max_page
          this.mappingData(devices)
          this.loadingData = false
        } 
      })();
    },
    async mappingData(data){
      let body = [];
      let result = data.results;
      await result.map(res => {
        let valuesData = [
          { value: res.id, display: "display:none;"},
          { header: true, 
            items:[
              {
                value: res.location
              },
              {
                value: res.name_campaign
              }
            ]
          },
          { value: res.placement},
          { value: parseInt(res.actual_play)},
          { value: parseInt(res.min_count)},
        ];
        body.push({
          id: res.id,
          values:valuesData
        });
      });
      this.data.body = body;
      this.count = result.length;
      this.isLoading = false
    },
    displayPeriod(start, end) {
      return `${lib.formatShortDate(start)} - ${lib.formatShortDate(end)}`
    },
    displayStatus(status) {
      return lib.displayLabelStatus(status)
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>